<template>
  <div class="page-teacher-report">
    <report-header :basicInfo="datas" @changeClassByData="changeClassByData" />

    <el-tabs
      v-model="activeName"
      @tab-click="onTabClick"
      class="mt-f-30 i-tab"
      :class="offsetClass"
    >
      <el-tab-pane
        :label="item.label"
        :name="item.name"
        lazy
        v-for="item in tabList"
        :key="item.name"
      >
        <component
          v-if="item.name == activeName"
          ref="TeacherReport"
          :is="item.component"
          :overviewData="datas"
          :questionId="questionId"
          :studentData="studentData"
          @change-data="onChangeData"
          @changeActiveName="changeActiveName"
          :changeData="changeClassColumn"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import { getOverview, getStuScoreList } from '@/api/pt';
import PracticeOverview from './components/practice-overview.vue';
import StudentStatistics from './components/student-statistics.vue';
import TeacherWrong from './components/teacher-wrong.vue';
import ReportHeader from './components/report-header.vue';
import TopicAnalysis from './components/topic-analysis.vue';

export default {
  name: 'TeacherReport',
  components: {
    ReportHeader,
  },
  data() {
    return {
      activeName: 'tea-practice',
      offsetClass: 'l-0',
      params: {},
      questionId: '',
      tabList: [
        {
          label: '练习概览',
          name: 'tea-practice',
          component: PracticeOverview,
        },
        {
          label: '学生统计',
          name: 'tea-statistics',
          component: StudentStatistics,
        },
        {
          label: '共性错题',
          name: 'tea-wrong',
          component: TeacherWrong,
        },
        {
          label: '题目分析',
          name: 'tea-analysis',
          component: TopicAnalysis,
        },
      ],
      datas: {},
      studentData: [], // 学生列表
      changeClassColumn: {}, // 记录变更后的值
    };
  },
  methods: {
    changeActiveName(val) {
      this.activeName = 'tea-analysis';
      this.offsetClass = 'l-2';
      this.questionId = val;
    },
    onTabClick(e) {
      this.offsetClass = `l-${e.index}`;
      this.activeName = e.name;
    },
    getData() {
      getOverview({
        school_id: this.params.schoolId,
        evaluate_id: this.params.evaluateId,
      }).then((res) => {
        if (res.code === 200) {
          this.datas = res.data;
        } else {
          this.$message({
            type: 'warning',
            message: res.msg,
          });
        }
      }).catch((e) => {
        console.log(e);
        this.$message({
          type: 'warning',
          message: e.msg,
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    // 改变父组件值
    onChangeData(data) {
      this.studentData = data;
    },
    changeClassByData(data) {
      this.changeClassColumn = data;
      this.params = {
        ...this.params,
        evaluateId: data.evaluate_id,
        schoolId: data.school_id,
        batchId: data.batch_id,
      };
      this.getData();
      this.getStudentScoreList('', this.changeClassColumn);
    },
    // 学生接口
    getStudentScoreList(value, data) {
      const { evaluateId, schoolId, classId } = this.$route.query;
      return getStuScoreList({
        evaluate_id: data.evaluate_id
          ? data.evaluate_id : evaluateId,
        school_id: schoolId,
        class_id: data.class_id ? data.class_id : classId,
        name: value,
      }).then((res) => {
        if (res.code === 200) {
          this.studentData = res.data || [];
          // 首次默认按倒叙排
          if (Number(this.params.fromType) === 3) {
            this.studentData.sort(this.compareSort('avg_right_rate', ''));
          } else {
            this.studentData.sort(this.compareSort('cost_time', ''));
          }
        }
      });
    },
    // 排序处理
    compareSort(data, type) {
      return (a, b) => {
        const sortA = a[data];
        const sortB = b[data];
        if (type === 'ascending') {
          return sortA - sortB;
        }
        return sortB - sortA;
      };
    },
  },
  created() {
    this.getStudentScoreList('', {});
  },
  mounted() {
    // 区分MT和AMT模式
    this.params = this.$route.query;
    console.log(this.params, '111');
    console.log(Number(this.params.fromType) === 4, 'wang');
    if (Number(this.params.fromType) === 4) {
      this.tabList = this.tabList.filter((item) => item.name !== 'tea-analysis');
    } else {
      this.tabList = this.tabList.filter((item) => item.name !== 'tea-wrong');
    }
    this.getData();
  },
  destroyed() {
    this.changeClassColumn = {};
  },
};
</script>

<style lang="scss" scoped>
.page-teacher-report {
  padding: 32px 32px 10px;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  background: #fff;
  position: relative;
}
/deep/ .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0;
}

/deep/ .el-tabs__nav-wrap {
  overflow: hidden;
  margin-bottom: -1px;
  position: relative;
  border-bottom: 9px solid #ebeef5;
}
// element tag 样式覆盖
.i-tab {
  /deep/ {
    .el-tabs__item {
      font-size: 17px;
      width: 100px;
      text-align: center;
      height: 56px;
      line-height: 56px;
      padding: 0 !important;
      margin: 0 20px;
      &.is-active {
        color: rgba(25, 137, 250, 1);
      }
    }
    .el-tabs__nav-wrap {
      overflow: visible;
      display: flex;
    }
    .el-tabs__nav-scroll {
      overflow: visible;
    }
    .el-tabs__active-bar {
      background-color: rgba(25, 137, 250, 1);
      height: 3px;
      border-radius: 2px;
      width: 100px !important;
      &::after {
        content: "";
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 13px;
        height: 13px;
        border: 2px solid rgba(25, 137, 250, 1);
        box-sizing: border-box;
        background: #fff;
        border-radius: 50%;
        top: -4px;
      }
    }
  }
}
.l-0 /deep/ {
  .el-tabs__active-bar {
    left: 18px;
  }
}
.l-1 /deep/ {
  .el-tabs__active-bar {
    left: 54px;
  }
}
.l-2 /deep/ {
  .el-tabs__active-bar {
    left: 96px;
  }
}
.l-3 /deep/ {
  .el-tabs__active-bar {
    left: 138px;
  }
}
.isFixed{
    position: fixed;
    top: 0px;
    right: -75.8vw;
    z-index: 4;
    width: 100%;
  }
</style>
